<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo de Comprobante - Nuevo</strong>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form" autocomplete="off" @submit.prevent="AddVoucher">
              <b-row>
               
     
                <b-col md="3">
                  <b-form-group label="Código:">
                    <b-form-input
                      type="text"
                      ref="code"
                      v-model="voucher.code"
                    ></b-form-input>
                    <small v-if="errors.code" class="form-text text-danger"
                      >Ingrese un código</small
                    >
                  </b-form-group>
                </b-col>
       
                <b-col md="5">
                  <b-form-group label="Nombre:">
                    <b-form-input
                      type="text"
                      ref="name"
                      v-model="voucher.name"
                      placeholder="Ingrese su nombre"
                    ></b-form-input>
                    <small v-if="errors.name" class="form-text text-danger">Ingrese un nombre</small>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Def. Venta ?:">
                    <select
                      ref="state"
                      v-model="voucher.default_sale"
                      class="form-control">
                      <option value="1">Si</option>
                      <option value="0">No</option>
                    </select>
                  </b-form-group>
                </b-col>
         
                <b-col md="2">
                  <b-form-group label="Estado :">
                    <select
                      ref="state"
                      v-model="voucher.state"
                      class="form-control">
                      <option value="1">Activo</option>
                      <option value="0">Inactivo</option>
                    </select>
                  </b-form-group>
                </b-col>
              


                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-button
                    type="submit"
                    class="form-control bg-primary text-white"
                    variant="primary"
                    >GUARDAR</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";

export default {
  name: "VoucherAdd",
  data() {
    return {
      module:'Voucher',
      voucher: {
        code: "",
        name: "",
        default_sale:0,
        state: 1,
      },

      ubigens: [],
      //errors
      errors: {
        code: false,
        name: false,
      },
      validate: false,
    };
  },
  mounted() {
  
  },
  methods: {
    AddVoucher,
    Validate,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};


function AddVoucher() {
  // validacion de campos obligatorios
  this.Validate();
  if (this.validate) {
    return false;
  }

  let me = this;
  let url = this.url_base + "voucher/add";
  let data = {
    code: this.voucher.code,
    name: this.voucher.name,
    default_sale: this.voucher.default_sale,
    state: this.voucher.state,
  };

  axios({
    method: "POST",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      token: this.token,
      module: this.module,
      role: 2,
    },
  })
    .then(function (response) {
      if (response.data.status == 201) {
        me.voucher.code = "";
        me.voucher.name = "";
        me.voucher.state = 1;
        Swal.fire("Sistema", "Se ha creado el nuevo comprobante", "success");
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

function Validate() {
  this.errors.code = this.voucher.code.length == 0 ? true : false;
  this.errors.name = this.voucher.name.length == 0 ? true : false;
  
  this.validate = this.errors.code == true ? true : false;
  this.validate = this.errors.name == true ? true : false;

}
</script>
